/* GALAURO V2: Shopify-native client behavior. No Base44 cart or checkout. */
(() => {
  'use strict';
  const root = () => (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const api = (name) => root().replace(/\/?$/, '/') + name;
  const isJa = document.documentElement.lang === 'ja';
  const money = (cents) => {
    const currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    try { return new Intl.NumberFormat(isJa ? 'ja-JP' : 'en-US', {style:'currency', currency}).format((Number(cents) || 0) / 100); }
    catch { return '$' + ((Number(cents) || 0) / 100).toFixed(2); }
  };
  const qs = (parent, selector) => parent.querySelector(selector);
  const qsa = (parent, selector) => Array.from(parent.querySelectorAll(selector));
  let toastTimeout;
  const toast = (msg) => {
    const el = document.querySelector('[data-gv2-toast]'); if (!el) return;
    el.textContent=msg; el.classList.add('is-visible');
    clearTimeout(toastTimeout); toastTimeout=setTimeout(()=>el.classList.remove('is-visible'),3400);
  };
  async function request(url, options={}) {
    const response = await fetch(url,{credentials:'same-origin',headers:{'Accept':'application/json',...(options.headers||{})},...options});
    const data = await response.json();
    if (!response.ok) throw new Error(data.description || data.message || (isJa?'操作に失敗しました':'Something went wrong'));
    return data;
  }
  const create = (tag, classname, text) => {
    const el=document.createElement(tag);if(classname)el.className=classname;if(text!==undefined)el.textContent=text;return el;
  };
  async function renderCart() {
    const drawer=document.querySelector('[data-gv2-drawer]');
    if (!drawer) return;
    const cart=await request(api('cart.js'));
    qsa(document,'[data-gv2-cart-count],[data-gv2-drawer-count]').forEach(e=>e.textContent=cart.item_count);
    const total=qs(drawer,'[data-gv2-cart-subtotal]');if(total)total.textContent=money(cart.total_price);
    const content=qs(drawer,'[data-gv2-cart-items]');
    if (!content) return;
    content.replaceChildren();
    if (!cart.items.length) {
      content.append(create('p','gv2-empty',isJa?'カートに商品はありません':'Your cart is empty. Choose a version to begin.'));
      return;
    }
    cart.items.forEach(item=>{
      const line=create('article','gv2-drawer-item');
      const img=create('img');img.src=item.image||'';img.alt=item.product_title||'';img.loading='lazy';
      const body=create('div');
      body.append(create('strong','',item.product_title||item.title||'Galauro'));
      body.append(create('small','',(item.variant_title||'')+' · '+(isJa?'数量':'Qty')+' '+item.quantity));
      const remove=create('button','gv2-remove',isJa?'削除':'Remove');
      remove.type='button';remove.addEventListener('click',async()=>{
        remove.disabled=true;
        try { await request(api('cart/change.js'),{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:item.key,quantity:0})});await renderCart(); }
        catch(e){toast(e.message);remove.disabled=false;}
      });
      body.append(remove);
      line.append(img,body,create('strong','',money(item.final_line_price)));content.append(line);
    });
  }
  const setCartOpen = async(open) => {
    const drawer=document.querySelector('[data-gv2-drawer]');
    const overlay=document.querySelector('[data-gv2-cart-overlay]');
    if(!drawer||!overlay)return;
    drawer.classList.toggle('is-open',open);
    overlay.classList.toggle('is-open',open);
    drawer.setAttribute('aria-hidden',open?'false':'true');
    overlay.setAttribute('aria-hidden',open?'false':'true');
    document.body.classList.toggle('gv2-cart-is-open',open);
    document.body.style.overflow=open?'hidden':'';
    if(open){try{await renderCart()}catch(e){toast(e.message)}qs(drawer,'[data-gv2-close-cart]')?.focus();}
  };
  const init = () => {
    const section=document.querySelector('.galv2-top');
    if (!section || section.dataset.v2Ready==='yes') return;
    section.dataset.v2Ready='yes';
    // Clear any stale cart scroll lock retained by Shopify's preview navigation.
    if (!document.querySelector('[data-gv2-drawer].is-open')) {
      document.body.classList.remove('gv2-cart-is-open');
      document.body.style.overflow='';
    }
    const form=qs(section,'#galauroV2Form');
    const options=qsa(section,'[data-gv2-option]');
    const price=qs(section,'[data-gv2-price]');
    const compare=qs(section,'[data-gv2-compare]');
    const saving=qs(section,'[data-gv2-saving]');
    const total=qs(section,'[data-gv2-total]');
    const qtyInput=qs(section,'[data-gv2-quantity]');
    const hiddenQty=qs(section,'[data-gv2-quantity-input]');
    const hiddenId=qs(section,'[data-gv2-variant-input]');
    const addBtn=qs(section,'[data-gv2-add]');
    const caption=qs(section,'[data-gv2-included]');
    let selected=options.find(el=>el.getAttribute('aria-checked')==='true')||options[0]||null;
    let qty=1;
    const redraw=()=>{
      if(!selected)return;
      const id=selected.dataset.variantId;
      const priceCents=Number(selected.dataset.priceCents||0);
      const compareCents=Number(selected.dataset.compareCents||0);
      const available=selected.dataset.available==='true';
      if(hiddenId)hiddenId.value=id;
      if(hiddenQty)hiddenQty.value=qty;
      if(qtyInput)qtyInput.value=qty;
      options.forEach(el=>el.setAttribute('aria-checked',el===selected?'true':'false'));
      if(price)price.textContent=selected.dataset.price;
      if(compare)compare.textContent=compareCents>priceCents?selected.dataset.compare:'';
      if(saving) {
        saving.hidden=!(compareCents>priceCents);
        saving.textContent=compareCents>priceCents?(isJa?'割引 ':'Save ')+money(compareCents-priceCents):'';
      }
      if(total)total.textContent=money(priceCents*qty);
      if(addBtn) addBtn.disabled=!available;
      if(caption)caption.textContent=(selected.querySelector('.gv2-option-title')?.firstChild?.textContent?.trim()||'')+(isJa?' スライドセット付属':' slide set included');
    };
    options.forEach(el=>el.addEventListener('click',()=>{selected=el;redraw()}));
    qs(section,'[data-gv2-decrease]')?.addEventListener('click',()=>{qty=Math.max(1,qty-1);redraw()});
    qs(section,'[data-gv2-increase]')?.addEventListener('click',()=>{qty=Math.min(99,qty+1);redraw()});
    redraw();
    const images=qsa(section,'[data-gv2-thumb]');
    const mainImg=qs(section,'[data-gv2-gallery-image]');
    const mainIndex=qs(section,'[data-gv2-gallery-index]');
    let activeIndex=0;
    const showImage=(index)=>{
      if(!images.length||!mainImg)return;
      activeIndex=(index+images.length)%images.length;
      const btn=images[activeIndex];mainImg.src=btn.dataset.image;mainImg.alt=btn.dataset.alt||'Galauro product';
      if(mainIndex)mainIndex.textContent=(activeIndex+1)+' / '+images.length;
      images.forEach((b,i)=>{b.classList.toggle('is-active',i===activeIndex);b.setAttribute('aria-pressed',i===activeIndex?'true':'false')});
    };
    images.forEach((b,i)=>b.addEventListener('click',()=>showImage(i)));
    qs(section,'[data-gv2-gallery-prev]')?.addEventListener('click',()=>showImage(activeIndex-1));
    qs(section,'[data-gv2-gallery-next]')?.addEventListener('click',()=>showImage(activeIndex+1));
    form?.addEventListener('submit',async(event)=>{
      event.preventDefault();
      if(!selected||!hiddenId?.value)return;
      addBtn.disabled=true;
      addBtn.dataset.loading='true';
      addBtn.style.opacity='0.65';
      try{
        await request(api('cart/add.js'),{method:'POST',body:new FormData(form)});
        await renderCart();
        await setCartOpen(true);
        toast(isJa?'カートに追加しました':'Added to your Shopify cart');
      }catch(err){
        toast(err.message||'Unable to add to cart');
      }finally{
        delete addBtn.dataset.loading;addBtn.style.opacity='';addBtn.disabled=selected.dataset.available!=='true';
      }
    });
    qsa(document,'[data-gv2-open-cart]').forEach(btn=>btn.addEventListener('click',()=>setCartOpen(true)));
    qsa(document,'[data-gv2-close-cart]').forEach(btn=>btn.addEventListener('click',()=>setCartOpen(false)));
    qsa(document,'[data-gv2-cart-overlay]').forEach(el=>el.addEventListener('click',()=>setCartOpen(false)));
    document.addEventListener('keydown',(e)=>{if(e.key==='Escape')setCartOpen(false)});
    const sceneBtns=qsa(document,'[data-gv2-scene]');
    const sceneImg=document.querySelector('[data-gv2-scene-image]');
    const sceneTitle=document.querySelector('[data-gv2-scene-title]');
    const sceneText=document.querySelector('[data-gv2-scene-text]');
    sceneBtns.forEach(btn=>btn.addEventListener('click',()=>{
      sceneBtns.forEach(b=>b.setAttribute('aria-pressed',b===btn?'true':'false'));
      if(sceneImg){sceneImg.src=btn.dataset.sceneSrc||'';sceneImg.alt=btn.dataset.sceneName||'';}
      if(sceneTitle)sceneTitle.textContent=btn.dataset.sceneName||'';
      if(sceneText)sceneText.textContent=btn.dataset.sceneDesc||'';
    }));
    renderCart().catch(()=>{});
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});
  else init();
  document.addEventListener('shopify:section:load',init);
})();